export default function stringToUint8Array(arrayString: string): Uint8Array | null {
  return arrayString ? new TextEncoder().encode(arrayString) : null;
}